import type { MarketSnapshotResult } from "./types";

/** Temporary market snapshot for UI testing. Replace with API response later. */
export function getMarketTestSnapshot(
  ticker: string,
  exchange: string | null
): MarketSnapshotResult {
  const now = Date.now();
  const history = Array.from({ length: 120 }, (_, index) => {
    const date = new Date(now - (119 - index) * 86_400_000);
    const base = 820 + Math.sin(index / 8) * 40 + index * 0.35;
    return {
      date: date.toISOString().slice(0, 10),
      close: Number(base.toFixed(2)),
    };
  });

  return {
    status: "ready",
    symbol: ticker,
    cached: true,
    snapshot: {
      quote: {
        symbol: ticker,
        shortName: ticker,
        exchange: exchange ?? "NSE",
        currency: "INR",
        price: history[history.length - 1]?.close ?? 860,
        change: 12.45,
        changePercent: 1.47,
        open: 848.2,
        previousClose: 847.55,
        dayLow: 842.1,
        dayHigh: 865.4,
        volume: 2_145_320,
        marketCap: 78_500_000_000,
        fiftyTwoWeekHigh: 980.5,
        fiftyTwoWeekLow: 610.2,
        marketTime: new Date().toISOString(),
      },
      fundamentals: {
        asOf: new Date().toISOString().slice(0, 10),
        marketCap: 78_500_000_000,
        enterpriseValue: 82_100_000_000,
        trailingPE: 18.42,
        forwardPE: 15.8,
        pegRatio: 1.12,
        priceToSales: 2.35,
        priceToBook: 3.1,
        evToRevenue: 2.55,
        evToEbitda: 11.4,
        profitMargin: 0.124,
        returnOnAssets: 0.086,
        returnOnEquity: 0.178,
        revenue: 33_400_000_000,
        netIncome: 4_140_000_000,
        dilutedEps: 46.2,
        totalCash: 5_200_000_000,
        debtToEquity: 42.5,
        leveredFreeCashFlow: 2_800_000_000,
      },
      history,
      news: [
        {
          title: `${ticker} shares rise on strong quarterly outlook`,
          url: "https://example.com/news/1",
          publisher: "Market Wire",
          publishedAt: new Date(now - 2 * 86_400_000).toISOString(),
        },
        {
          title: `Analysts maintain overweight on ${ticker}`,
          url: "https://example.com/news/2",
          publisher: "Equity Desk",
          publishedAt: new Date(now - 5 * 86_400_000).toISOString(),
        },
      ],
      fetchedAt: new Date().toISOString(),
    },
  };
}
